import { createFileRoute, redirect } from '@tanstack/react-router'
import InviteLandingPage from '@/pages/invites'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/invites/$inviteId')({
  beforeLoad: ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    if (context.auth.status === 'UNAUTHENTICATED') {
      throw redirect({
        to: '/$lang/login',
        params: { lang: params.lang },
      })
    }
  },
  component: InviteLandingPage,
  staticData: { layout: 'public' },
})
